<template>
    <div class="font-opensans vs-page">
      <div class="card shadow-sm vs-filter-card">
        <div class="vs-header">
          <div class="vs-header-title">
            <b-icon icon="tags" font-scale="1.1"></b-icon>
            <span>Vista de Tipos de Producto</span>
          </div>
          <div class="vs-header-actions">
            <b-button v-if="!cargando" :hidden="ocultarnuevo" class="vs-action-btn" @click="nuevoTipo()">
              <b-icon icon="plus-circle"></b-icon> Nuevo
            </b-button>
            <b-spinner v-else class="text-center" variant="warning"></b-spinner>
          </div>
        </div>
        <div class="vs-filters">
          <b-input-group size="sm">
            <b-form-input v-model="filter" type="search" placeholder="Escribe para filtrar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''" class="vs-clear-btn">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="my-table" size="sm" pills align="center" class="mt-2">
          </b-pagination>
        </div>
      </div>
      <div class="card shadow-sm mt-3 vs-data-card">
        <b-table v-if="!cargando" hover small :items="tipo_producto" :fields="fields" selectable responsive striped
                caption-top :filter="filter" select-mode="single" :per-page="perPage"
                :current-page="currentPage" label-sort-asc="" label-sort-desc="" label-sort-clear=""
                style="font-size:12px;" table-class="custom-table" thead-class="table-header" tbody-class="table-body">
          <template #table-caption><strong class="fcgreen">tipos de producto: {{ tipo_producto.length }}</strong></template>
          <template #cell(edit)="data">
            <b-button size="sm" variant="outline-dark" @click="editarTipoProducto(data.item)">Editar</b-button>
          </template>
        </b-table>
        <b-spinner v-else class="text-center" variant="warning"></b-spinner>
      </div>
      <Modals ref="mod"></Modals>
    </div>
</template>
<script>
import Modals from '@/components/Modals.vue'
// import Operadores from '@/catalogos/Operadores.vue'
import {mapState,mapActions} from 'vuex'
import * as utils from "@/shared/util"

export default {
    data() {
        return {
            texto: 'tipo_producto',
            currentPage:1,
            perPage:10,
            fields:[{key: 'tipo_producto_id', label: 'suministro_id', class:"d-none"},
                    {key: 'descripcion', label: 'Descripcion', sortable: true},
                    {key: 'edit', label: 'Acción', sortable: true},
                    // {key: 'DIFERENCIA', label: 'DIF', class:'negritas'},
                    ],
            tipo_producto:[],
            filter:'',
            cargando:false,
        }
    },
    components: {
        Modals,
        // Operadores,
    },
    computed: {
        ...mapState(['operador','modal','menu']),
        rows() {
            return this.tipo_producto.length
        },
        ocultarnuevo(){
            // if(this.tabselected==0 ){
            //     return true
            // }else{
                return false
            // }
        },
    },
    created () {
        // let f=Date();
        //  this.ffin= utils.getDateTime(f)
        //  this.fini=this.ffin
       //console.warn("la ruta: " + this.$route.name)
        this.gettipo_producto()
    },
    methods: {
        ...mapActions(['actupdateMenu','actupdateModal']),
        showmodal(tittle,message){
            this.modal.tittle = tittle
            this.modal.message = message
            this.modal.type = 0
            this.actupdateModal(this.modal)
            // console.log("ahora contiene:  " + JSON.stringify(this.modal))
            this.$refs.mod.showmodal()
        },
        gettipo_producto() {
            this.cargando=true
            this.$store.dispatch("getTiposProductos").then((resp)=>{

                // console.warn("La respuesta de getoperadores: " + JSON.stringify(resp))
                if(resp.estatus == 1){
                    // this.operadores=resp.data
                    this.tipo_producto=resp.tipo_producto
                    this.cargando=false
                }else{
                    this.showmodal(this.texto, resp.message)
                    this.cargando=false
                }
            }).catch((err)=>{
                this.showmodal(this.texto, err)
                this.cargando=false
            })
        },
       
        nuevoTipo(){
            // this.$router.push({ name: 'tipo_producto' });
           //console.warn("la ruta: " + this.$route.name)
            if (this.$route.name !== 'tipos_productos') {
                this.$router.push({ name: 'tipos_productos' });
            }
        },
        editarTipoProducto(item){
           //console.log("editando tipo de producto")
            this.$router.push({ name: 'tipos_productos', params: item});
        },
        // formatearNumero(numero) {
        //     numero = parseFloat(numero);

        //     if (isNaN(numero)) {
        //         return 'Invalido';
        //     }
        //     let partes = numero.toFixed(2).toString().split('.');
        //     // Agregar comas para separar los miles
        //     partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        //     // Unir las partes entera y decimal con un punto decimal
        //     return partes.join('.');
        // },
        imprimir(){
            //  console.log("EL tabselected: " + this.tabselected)
            //  if(this.tabselected===0){ 
            //      utils.exportar(this.renglonaje,'renglonaje')
            //  }else if(this.tabselected===1){
            utils.exportar(this.tipo_producto,'Tipos de producto')
            //  }
         },
    },
}
</script>

<style scoped>
@import "@/assets/css/app.css";
</style>
